export enum eTipoPesquisaFiltroTurmas {
    Rede = "Rede",
    Escola = "Escola"
}

export class ModalFiltroTurmasParams {
    eTipoPesquisaFiltroTurmas: eTipoPesquisaFiltroTurmas = eTipoPesquisaFiltroTurmas.Escola;
    parametrosTelaEnturmacao: string = '';
    route: string = '';
}